<template>
    <el-container style="width:100%;" v-loading.body="loading">
        <el-main>

            <el-card class="box-card">
                <div slot="header" class="clearfix label">
                    <span>
                        <i class="el-icon-money"></i>
                        {{$t('bankingSolutions.title')}}
                    </span>
                </div>
                <div class="text item">
                    {{$t('bankingSolutions.desc')}}
                </div>
            </el-card>

            <el-card class="box-card" style="margin-top: 50px;">
                <div class="text item">
                    <el-row>
                        <el-col :span="15" class="labels-card">
                            <div>
                                <label>{{$t('bankingSolutions.multiCurrencyTitle')}}</label>
                                <p>{{$t('bankingSolutions.multiCurrencyDesc')}}</p>
                            </div>

                            <div>
                                <label>{{$t('bankingSolutions.rewardsTitle')}}</label>
                                <p>{{$t('bankingSolutions.rewardsDesc')}}</p>
                            </div>

                            <div>
                                <label>{{$t('bankingSolutions.IntegrationTitle')}}</label>
                                <p>{{$t('bankingSolutions.IntegrationDesc')}}</p>
                            </div>

                            <div>
                                <label>{{$t('bankingSolutions.supportTitle')}}</label>
                                <p>{{$t('bankingSolutions.supportDesc')}}</p>
                            </div>
                        </el-col>
                        <el-col :span="9" style="margin-top: 50px;">
                            <img :src="instruction" width="100%" />
                        </el-col>
                    </el-row>
                </div>
            </el-card>

            <el-card class="box-card" style="margin-top: 50px;">
                <div slot="header" class="clearfix label">
                    <span>
                        <i class="el-icon-bank-card"></i>
                        {{$t('bankingSolutions.mieCard')}}
                    </span>
                </div>
                <div class="text item">
                    {{$t('bankingSolutions.mieCardDesc')}}
                </div>

                <div class="text item">
                    <el-row>
                        <el-col :span="15" class="labels-card">
                            <div style="margin-top: 25px;">
                                <label>{{$t('bankingSolutions.points')}}</label>
                                <p>{{$t('bankingSolutions.pointsDesc')}}</p>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <img :src="unionCard" width="90%" />
                        </el-col>
                    </el-row>
                </div>
            </el-card>

        </el-main>
    </el-container>
</template>
<style rel="stylesheet/scss" lang="scss" scoped>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  label, .label{
    font-weight: 500;
  }

  .labels-card > div{
    margin-top : 35px;
  }
  .labels-card :first-child{
    margin-top : 5px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
    font-weight: 500;
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    margin: 0 auto;
    width: 780px;
  }
</style>

<script>
import instruction from '@/assets/img/banking/instruction.jpeg'
import unionCard from '@/assets/img/banking/union_card.jpeg'

export default {
  name: 'banking',
  data() {
    return {
      instruction: instruction,
      unionCard: unionCard
    }
  }
}

</script>
